/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForSecureScore extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForSecureScore.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForSecureScore>): ProgressDetailsForSecureScore {
        let obj = Object.assign(new ProgressDetailsForSecureScore(), model);
        ProgressDetailsForSecureScore.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForSecureScore>): ProgressDetailsForSecureScore {
        if (!model) return null;
        return ProgressDetailsForSecureScore.newInstance(<ProgressDetailsForSecureScore> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForSecureScore) {
        if (!obj) return;

        models.ProgressDetailsForSecureScore.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForSecureScore): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForSecureScore.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Secure Score
     */
    secure_score: string;

}
